import {isApiTrue}        from "@Common/logic/is-api-true";
import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Load2}            from "@Common/react/load2";
import {BlockGuestAccess} from "@Common/logic/block-guest-access";

export const AddressData = ({agentId=undefined, branchId=undefined, next}) => cs(
    consumeContext("apis"),
    consumeContext("company"),

    ["myAddresses", ({apis}, next) => Load2({
        fetch: async () => apis.next.shipping.getMyShippingAddresses({idEntity: agentId}),
        next,
    })],
    ["blockGuestAccess", (_, next) => BlockGuestAccess({next})],
    ["officeAddress", ({apis, company, blockGuestAccess}, next) => {
        const allow = isApiTrue(company?.prefs?.allowShipToBranch) && !blockGuestAccess;
        return Load2({
            _key: allow,
            fetch: async () => allow ? (
                apis.next.shipping.getOfficeShippingAddress({idBranch: branchId})
            ) : (
                null
            ),
            next,
        });
    }],
    ({myAddresses, officeAddress}) => next({
        loading: myAddresses.loading || officeAddress.loading,
        myAddresses, officeAddress,
    })
);
